import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const MenuContentContainer = styled.div`
  background: linear-gradient(
    89deg,
    rgba(15, 15, 15, 0.8) 1.8%,
    rgba(82, 82, 82, 0) 95.07%
  );
  display: flex;
  flex-direction: column;
  height: ${880 * Screen.widthRatio}px;
  padding: ${200 * Screen.widthRatio}px 0 0 0;
  position: absolute;
  width: ${523 * Screen.widthRatio}px;
`;

export default MenuContentContainer;
